import { createFormHook } from '@tanstack/react-form';
import { fieldContext, formContext } from './form-field-utils';
import { SubmitButton } from './SubmitButton';

export const { useAppForm } = createFormHook({
  fieldContext,
  formContext,
  // Empty so fields bind only through AppFieldOf; a registered component would allow field.X too.
  fieldComponents: {},
  formComponents: { SubmitButton }
});
